// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file issue/issue.proto (package vsmr.issue.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";

/**
 * 이슈를 쓴 앱 — 활동 기록이 앱별로 갈린다(게시판 자체는 공유).
 *
 * @generated from enum vsmr.issue.v1.IssueOrigin
 */
export enum IssueOrigin {
  /**
   * 모름 — 서버는 sim-web 으로 기록한다(출처를 보내기 전의 클라이언트와 같은 결과).
   *
   * @generated from enum value: ISSUE_ORIGIN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ISSUE_ORIGIN_SIM_WEB = 1;
   */
  SIM_WEB = 1,

  /**
   * @generated from enum value: ISSUE_ORIGIN_OPERATION_HMI = 2;
   */
  OPERATION_HMI = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(IssueOrigin)
proto3.util.setEnumType(IssueOrigin, "vsmr.issue.v1.IssueOrigin", [
  { no: 0, name: "ISSUE_ORIGIN_UNSPECIFIED" },
  { no: 1, name: "ISSUE_ORIGIN_SIM_WEB" },
  { no: 2, name: "ISSUE_ORIGIN_OPERATION_HMI" },
]);

/**
 * 이 서비스 요청의 상한 — 선언 하나. enum 은 숫자를 모든 생성 언어에 싣는 수단일 뿐이고 이것을 쓰는 메시지 필드는 없다:
 * BFF 가 강제하고(본문 상한은 여기서 유도), 웹은 보내기 전에 검사한다.
 *
 * @generated from enum vsmr.issue.v1.IssueLimit
 */
export enum IssueLimit {
  /**
   * @generated from enum value: ISSUE_LIMIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 첨부 하나의 바이트 상한(5 MiB)
   *
   * @generated from enum value: ISSUE_LIMIT_ATTACHMENT_MAX_BYTES = 5242880;
   */
  ATTACHMENT_MAX_BYTES = 5242880,
}
// Retrieve enum metadata with: proto3.getEnumType(IssueLimit)
proto3.util.setEnumType(IssueLimit, "vsmr.issue.v1.IssueLimit", [
  { no: 0, name: "ISSUE_LIMIT_UNSPECIFIED" },
  { no: 5242880, name: "ISSUE_LIMIT_ATTACHMENT_MAX_BYTES" },
]);

/**
 * @generated from message vsmr.issue.v1.Issue
 */
export class Issue extends Message<Issue> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * 사람 친화 순번 — "#12" 표기용 (전역 단조 증가)
   *
   * @generated from field: int64 number = 2;
   */
  number = protoInt64.zero;

  /**
   * @generated from field: string author_id = 3;
   */
  authorId = "";

  /**
   * user_profiles.display_name 조인 (표시용 — 빈 값 가능)
   *
   * @generated from field: string author_name = 4;
   */
  authorName = "";

  /**
   * @generated from field: string title = 5;
   */
  title = "";

  /**
   * 마크다운 본문
   *
   * @generated from field: string body = 6;
   */
  body = "";

  /**
   * open | closed
   *
   * @generated from field: string state = 7;
   */
  state = "";

  /**
   * closed 사유: completed | not_planned, reopen 후엔 reopened. open 초기엔 빈 값.
   *
   * @generated from field: string state_reason = 8;
   */
  stateReason = "";

  /**
   * admin 이 붙이는 자유 라벨 (예: bug, enhancement, question, in progress)
   *
   * @generated from field: repeated string labels = 9;
   */
  labels: string[] = [];

  /**
   * 담당 admin (선택)
   *
   * @generated from field: string assignee_id = 10;
   */
  assigneeId = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp closed_at = 13;
   */
  closedAt?: Timestamp;

  /**
   * 목록 화면용 코멘트 수 — 삭제된 코멘트는 세지 않는다
   *
   * @generated from field: int32 comment_count = 14;
   */
  commentCount = 0;

  /**
   * 제목·본문을 마지막으로 편집한 시각. 편집한 적 없으면 생략.
   *
   * @generated from field: google.protobuf.Timestamp edited_at = 15;
   */
  editedAt?: Timestamp;

  constructor(data?: PartialMessage<Issue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.Issue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "author_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "author_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "state_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "labels", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "assignee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "created_at", kind: "message", T: Timestamp },
    { no: 12, name: "updated_at", kind: "message", T: Timestamp },
    { no: 13, name: "closed_at", kind: "message", T: Timestamp },
    { no: 14, name: "comment_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "edited_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Issue {
    return new Issue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Issue {
    return new Issue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Issue {
    return new Issue().fromJsonString(jsonString, options);
  }

  static equals(a: Issue | PlainMessage<Issue> | undefined, b: Issue | PlainMessage<Issue> | undefined): boolean {
    return proto3.util.equals(Issue, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.IssueComment
 */
export class IssueComment extends Message<IssueComment> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string issue_id = 2;
   */
  issueId = "";

  /**
   * @generated from field: string author_id = 3;
   */
  authorId = "";

  /**
   * @generated from field: string author_name = 4;
   */
  authorName = "";

  /**
   * 삭제된 코멘트는 빈 문자열 — 화면은 자리 표시("삭제된 댓글")를 그린다
   *
   * @generated from field: string body = 5;
   */
  body = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * 본문을 마지막으로 편집한 시각. 편집한 적 없으면 생략.
   *
   * @generated from field: google.protobuf.Timestamp edited_at = 7;
   */
  editedAt?: Timestamp;

  /**
   * 소프트 삭제됨 — 목록에 남되 본문은 비어 있다
   *
   * @generated from field: bool deleted = 8;
   */
  deleted = false;

  /**
   * 지운 사람(작성자 본인 또는 admin). 삭제되지 않았으면 빈 값.
   *
   * @generated from field: string deleted_by = 9;
   */
  deletedBy = "";

  constructor(data?: PartialMessage<IssueComment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.IssueComment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "issue_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "author_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "author_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "edited_at", kind: "message", T: Timestamp },
    { no: 8, name: "deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "deleted_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IssueComment {
    return new IssueComment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IssueComment {
    return new IssueComment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IssueComment {
    return new IssueComment().fromJsonString(jsonString, options);
  }

  static equals(a: IssueComment | PlainMessage<IssueComment> | undefined, b: IssueComment | PlainMessage<IssueComment> | undefined): boolean {
    return proto3.util.equals(IssueComment, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.UpdateIssueRequest
 */
export class UpdateIssueRequest extends Message<UpdateIssueRequest> {
  /**
   * @generated from field: string issue_id = 1;
   */
  issueId = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string body = 3;
   */
  body = "";

  constructor(data?: PartialMessage<UpdateIssueRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.UpdateIssueRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "issue_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateIssueRequest {
    return new UpdateIssueRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateIssueRequest {
    return new UpdateIssueRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateIssueRequest {
    return new UpdateIssueRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateIssueRequest | PlainMessage<UpdateIssueRequest> | undefined, b: UpdateIssueRequest | PlainMessage<UpdateIssueRequest> | undefined): boolean {
    return proto3.util.equals(UpdateIssueRequest, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.UpdateIssueCommentRequest
 */
export class UpdateIssueCommentRequest extends Message<UpdateIssueCommentRequest> {
  /**
   * @generated from field: string issue_id = 1;
   */
  issueId = "";

  /**
   * @generated from field: string comment_id = 2;
   */
  commentId = "";

  /**
   * @generated from field: string body = 3;
   */
  body = "";

  constructor(data?: PartialMessage<UpdateIssueCommentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.UpdateIssueCommentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "issue_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "comment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateIssueCommentRequest {
    return new UpdateIssueCommentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateIssueCommentRequest {
    return new UpdateIssueCommentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateIssueCommentRequest {
    return new UpdateIssueCommentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateIssueCommentRequest | PlainMessage<UpdateIssueCommentRequest> | undefined, b: UpdateIssueCommentRequest | PlainMessage<UpdateIssueCommentRequest> | undefined): boolean {
    return proto3.util.equals(UpdateIssueCommentRequest, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.DeleteIssueCommentRequest
 */
export class DeleteIssueCommentRequest extends Message<DeleteIssueCommentRequest> {
  /**
   * @generated from field: string issue_id = 1;
   */
  issueId = "";

  /**
   * @generated from field: string comment_id = 2;
   */
  commentId = "";

  constructor(data?: PartialMessage<DeleteIssueCommentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.DeleteIssueCommentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "issue_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "comment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteIssueCommentRequest {
    return new DeleteIssueCommentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteIssueCommentRequest {
    return new DeleteIssueCommentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteIssueCommentRequest {
    return new DeleteIssueCommentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteIssueCommentRequest | PlainMessage<DeleteIssueCommentRequest> | undefined, b: DeleteIssueCommentRequest | PlainMessage<DeleteIssueCommentRequest> | undefined): boolean {
    return proto3.util.equals(DeleteIssueCommentRequest, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.CreateIssueRequest
 */
export class CreateIssueRequest extends Message<CreateIssueRequest> {
  /**
   * @generated from field: string title = 1;
   */
  title = "";

  /**
   * @generated from field: string body = 2;
   */
  body = "";

  /**
   * @generated from field: vsmr.issue.v1.IssueOrigin origin = 3;
   */
  origin = IssueOrigin.UNSPECIFIED;

  constructor(data?: PartialMessage<CreateIssueRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.CreateIssueRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "origin", kind: "enum", T: proto3.getEnumType(IssueOrigin) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateIssueRequest {
    return new CreateIssueRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateIssueRequest {
    return new CreateIssueRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateIssueRequest {
    return new CreateIssueRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateIssueRequest | PlainMessage<CreateIssueRequest> | undefined, b: CreateIssueRequest | PlainMessage<CreateIssueRequest> | undefined): boolean {
    return proto3.util.equals(CreateIssueRequest, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.ListIssuesRequest
 */
export class ListIssuesRequest extends Message<ListIssuesRequest> {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize = 0;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken = "";

  /**
   * "" = 전체, open | closed
   *
   * @generated from field: string state = 3;
   */
  state = "";

  /**
   * admin 전용 — 전 사용자 이슈 열람
   *
   * @generated from field: bool all_users = 4;
   */
  allUsers = false;

  constructor(data?: PartialMessage<ListIssuesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.ListIssuesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "all_users", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListIssuesRequest {
    return new ListIssuesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListIssuesRequest {
    return new ListIssuesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListIssuesRequest {
    return new ListIssuesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListIssuesRequest | PlainMessage<ListIssuesRequest> | undefined, b: ListIssuesRequest | PlainMessage<ListIssuesRequest> | undefined): boolean {
    return proto3.util.equals(ListIssuesRequest, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.ListIssuesResponse
 */
export class ListIssuesResponse extends Message<ListIssuesResponse> {
  /**
   * @generated from field: repeated vsmr.issue.v1.Issue issues = 1;
   */
  issues: Issue[] = [];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListIssuesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.ListIssuesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "issues", kind: "message", T: Issue, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListIssuesResponse {
    return new ListIssuesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListIssuesResponse {
    return new ListIssuesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListIssuesResponse {
    return new ListIssuesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListIssuesResponse | PlainMessage<ListIssuesResponse> | undefined, b: ListIssuesResponse | PlainMessage<ListIssuesResponse> | undefined): boolean {
    return proto3.util.equals(ListIssuesResponse, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.GetIssueRequest
 */
export class GetIssueRequest extends Message<GetIssueRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetIssueRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.GetIssueRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIssueRequest {
    return new GetIssueRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIssueRequest {
    return new GetIssueRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIssueRequest {
    return new GetIssueRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetIssueRequest | PlainMessage<GetIssueRequest> | undefined, b: GetIssueRequest | PlainMessage<GetIssueRequest> | undefined): boolean {
    return proto3.util.equals(GetIssueRequest, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.GetIssueDetailResponse
 */
export class GetIssueDetailResponse extends Message<GetIssueDetailResponse> {
  /**
   * @generated from field: vsmr.issue.v1.Issue issue = 1;
   */
  issue?: Issue;

  /**
   * 시간순 앞에서부터 최대 300개 — 유한 응답 계약(게시판 용도 상한).
   * 초과가 실제로 발생하면 커서 페이지네이션을 그때 도입한다.
   *
   * @generated from field: repeated vsmr.issue.v1.IssueComment comments = 2;
   */
  comments: IssueComment[] = [];

  constructor(data?: PartialMessage<GetIssueDetailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.GetIssueDetailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "issue", kind: "message", T: Issue },
    { no: 2, name: "comments", kind: "message", T: IssueComment, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIssueDetailResponse {
    return new GetIssueDetailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIssueDetailResponse {
    return new GetIssueDetailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIssueDetailResponse {
    return new GetIssueDetailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetIssueDetailResponse | PlainMessage<GetIssueDetailResponse> | undefined, b: GetIssueDetailResponse | PlainMessage<GetIssueDetailResponse> | undefined): boolean {
    return proto3.util.equals(GetIssueDetailResponse, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.AddIssueCommentRequest
 */
export class AddIssueCommentRequest extends Message<AddIssueCommentRequest> {
  /**
   * @generated from field: string issue_id = 1;
   */
  issueId = "";

  /**
   * @generated from field: string body = 2;
   */
  body = "";

  constructor(data?: PartialMessage<AddIssueCommentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.AddIssueCommentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "issue_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddIssueCommentRequest {
    return new AddIssueCommentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddIssueCommentRequest {
    return new AddIssueCommentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddIssueCommentRequest {
    return new AddIssueCommentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AddIssueCommentRequest | PlainMessage<AddIssueCommentRequest> | undefined, b: AddIssueCommentRequest | PlainMessage<AddIssueCommentRequest> | undefined): boolean {
    return proto3.util.equals(AddIssueCommentRequest, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.IssueCommentResponse
 */
export class IssueCommentResponse extends Message<IssueCommentResponse> {
  /**
   * @generated from field: vsmr.issue.v1.IssueComment comment = 1;
   */
  comment?: IssueComment;

  constructor(data?: PartialMessage<IssueCommentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.IssueCommentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "comment", kind: "message", T: IssueComment },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IssueCommentResponse {
    return new IssueCommentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IssueCommentResponse {
    return new IssueCommentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IssueCommentResponse {
    return new IssueCommentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: IssueCommentResponse | PlainMessage<IssueCommentResponse> | undefined, b: IssueCommentResponse | PlainMessage<IssueCommentResponse> | undefined): boolean {
    return proto3.util.equals(IssueCommentResponse, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.UpdateIssueStateRequest
 */
export class UpdateIssueStateRequest extends Message<UpdateIssueStateRequest> {
  /**
   * @generated from field: string issue_id = 1;
   */
  issueId = "";

  /**
   * open | closed
   *
   * @generated from field: string state = 2;
   */
  state = "";

  /**
   * close 시: completed(기본) | not_planned. open 전환 시 무시(reopened 로 기록).
   *
   * @generated from field: string state_reason = 3;
   */
  stateReason = "";

  constructor(data?: PartialMessage<UpdateIssueStateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.UpdateIssueStateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "issue_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "state_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateIssueStateRequest {
    return new UpdateIssueStateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateIssueStateRequest {
    return new UpdateIssueStateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateIssueStateRequest {
    return new UpdateIssueStateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateIssueStateRequest | PlainMessage<UpdateIssueStateRequest> | undefined, b: UpdateIssueStateRequest | PlainMessage<UpdateIssueStateRequest> | undefined): boolean {
    return proto3.util.equals(UpdateIssueStateRequest, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.UpdateIssueMetaRequest
 */
export class UpdateIssueMetaRequest extends Message<UpdateIssueMetaRequest> {
  /**
   * @generated from field: string issue_id = 1;
   */
  issueId = "";

  /**
   * set_labels 가 true 일 때만 적용 — proto3 repeated 는 "생략"과
   * "전부 삭제"를 구분하지 못하므로 존재 플래그를 명시한다.
   *
   * @generated from field: repeated string labels = 2;
   */
  labels: string[] = [];

  /**
   * @generated from field: string assignee_id = 3;
   */
  assigneeId = "";

  /**
   * assignee 해제 (빈 assignee_id 와 "미변경"을 구분)
   *
   * @generated from field: bool clear_assignee = 4;
   */
  clearAssignee = false;

  /**
   * 라벨 교체 의도 명시 (false 면 기존 라벨 유지)
   *
   * @generated from field: bool set_labels = 5;
   */
  setLabels = false;

  constructor(data?: PartialMessage<UpdateIssueMetaRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.UpdateIssueMetaRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "issue_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "labels", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "assignee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "clear_assignee", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "set_labels", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateIssueMetaRequest {
    return new UpdateIssueMetaRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateIssueMetaRequest {
    return new UpdateIssueMetaRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateIssueMetaRequest {
    return new UpdateIssueMetaRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateIssueMetaRequest | PlainMessage<UpdateIssueMetaRequest> | undefined, b: UpdateIssueMetaRequest | PlainMessage<UpdateIssueMetaRequest> | undefined): boolean {
    return proto3.util.equals(UpdateIssueMetaRequest, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.IssueResponse
 */
export class IssueResponse extends Message<IssueResponse> {
  /**
   * @generated from field: vsmr.issue.v1.Issue issue = 1;
   */
  issue?: Issue;

  constructor(data?: PartialMessage<IssueResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.IssueResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "issue", kind: "message", T: Issue },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IssueResponse {
    return new IssueResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IssueResponse {
    return new IssueResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IssueResponse {
    return new IssueResponse().fromJsonString(jsonString, options);
  }

  static equals(a: IssueResponse | PlainMessage<IssueResponse> | undefined, b: IssueResponse | PlainMessage<IssueResponse> | undefined): boolean {
    return proto3.util.equals(IssueResponse, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.IssueAttachment
 */
export class IssueAttachment extends Message<IssueAttachment> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string file_name = 2;
   */
  fileName = "";

  /**
   * 서버가 받는 형식 — GetIssueAttachmentPolicy 가 그 목록을 알린다
   *
   * @generated from field: string content_type = 3;
   */
  contentType = "";

  /**
   * @generated from field: int64 size = 4;
   */
  size = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  constructor(data?: PartialMessage<IssueAttachment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.IssueAttachment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IssueAttachment {
    return new IssueAttachment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IssueAttachment {
    return new IssueAttachment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IssueAttachment {
    return new IssueAttachment().fromJsonString(jsonString, options);
  }

  static equals(a: IssueAttachment | PlainMessage<IssueAttachment> | undefined, b: IssueAttachment | PlainMessage<IssueAttachment> | undefined): boolean {
    return proto3.util.equals(IssueAttachment, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.GetIssueAttachmentPolicyRequest
 */
export class GetIssueAttachmentPolicyRequest extends Message<GetIssueAttachmentPolicyRequest> {
  constructor(data?: PartialMessage<GetIssueAttachmentPolicyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.GetIssueAttachmentPolicyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIssueAttachmentPolicyRequest {
    return new GetIssueAttachmentPolicyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIssueAttachmentPolicyRequest {
    return new GetIssueAttachmentPolicyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIssueAttachmentPolicyRequest {
    return new GetIssueAttachmentPolicyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetIssueAttachmentPolicyRequest | PlainMessage<GetIssueAttachmentPolicyRequest> | undefined, b: GetIssueAttachmentPolicyRequest | PlainMessage<GetIssueAttachmentPolicyRequest> | undefined): boolean {
    return proto3.util.equals(GetIssueAttachmentPolicyRequest, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.IssueAttachmentPolicy
 */
export class IssueAttachmentPolicy extends Message<IssueAttachmentPolicy> {
  /**
   * 받는 첨부 형식(MIME, 소문자, 정렬) — 업로드는 이 밖의 형식을 INVALID_ARGUMENT 로 거절한다
   *
   * @generated from field: repeated string content_types = 1;
   */
  contentTypes: string[] = [];

  constructor(data?: PartialMessage<IssueAttachmentPolicy>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.IssueAttachmentPolicy";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IssueAttachmentPolicy {
    return new IssueAttachmentPolicy().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IssueAttachmentPolicy {
    return new IssueAttachmentPolicy().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IssueAttachmentPolicy {
    return new IssueAttachmentPolicy().fromJsonString(jsonString, options);
  }

  static equals(a: IssueAttachmentPolicy | PlainMessage<IssueAttachmentPolicy> | undefined, b: IssueAttachmentPolicy | PlainMessage<IssueAttachmentPolicy> | undefined): boolean {
    return proto3.util.equals(IssueAttachmentPolicy, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.UploadIssueAttachmentRequest
 */
export class UploadIssueAttachmentRequest extends Message<UploadIssueAttachmentRequest> {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName = "";

  /**
   * @generated from field: string content_type = 2;
   */
  contentType = "";

  /**
   * 이미지 바이트 — 서버가 크기 상한(ISSUE_LIMIT_ATTACHMENT_MAX_BYTES)·형식 목록(IssueAttachmentPolicy)을 강제한다
   *
   * @generated from field: bytes content = 3;
   */
  content = new Uint8Array(0);

  constructor(data?: PartialMessage<UploadIssueAttachmentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.UploadIssueAttachmentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadIssueAttachmentRequest {
    return new UploadIssueAttachmentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadIssueAttachmentRequest {
    return new UploadIssueAttachmentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadIssueAttachmentRequest {
    return new UploadIssueAttachmentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UploadIssueAttachmentRequest | PlainMessage<UploadIssueAttachmentRequest> | undefined, b: UploadIssueAttachmentRequest | PlainMessage<UploadIssueAttachmentRequest> | undefined): boolean {
    return proto3.util.equals(UploadIssueAttachmentRequest, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.IssueAttachmentResponse
 */
export class IssueAttachmentResponse extends Message<IssueAttachmentResponse> {
  /**
   * @generated from field: vsmr.issue.v1.IssueAttachment attachment = 1;
   */
  attachment?: IssueAttachment;

  constructor(data?: PartialMessage<IssueAttachmentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.IssueAttachmentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "attachment", kind: "message", T: IssueAttachment },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IssueAttachmentResponse {
    return new IssueAttachmentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IssueAttachmentResponse {
    return new IssueAttachmentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IssueAttachmentResponse {
    return new IssueAttachmentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: IssueAttachmentResponse | PlainMessage<IssueAttachmentResponse> | undefined, b: IssueAttachmentResponse | PlainMessage<IssueAttachmentResponse> | undefined): boolean {
    return proto3.util.equals(IssueAttachmentResponse, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.GetIssueAttachmentRequest
 */
export class GetIssueAttachmentRequest extends Message<GetIssueAttachmentRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetIssueAttachmentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.GetIssueAttachmentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIssueAttachmentRequest {
    return new GetIssueAttachmentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIssueAttachmentRequest {
    return new GetIssueAttachmentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIssueAttachmentRequest {
    return new GetIssueAttachmentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetIssueAttachmentRequest | PlainMessage<GetIssueAttachmentRequest> | undefined, b: GetIssueAttachmentRequest | PlainMessage<GetIssueAttachmentRequest> | undefined): boolean {
    return proto3.util.equals(GetIssueAttachmentRequest, a, b);
  }
}

/**
 * @generated from message vsmr.issue.v1.GetIssueAttachmentResponse
 */
export class GetIssueAttachmentResponse extends Message<GetIssueAttachmentResponse> {
  /**
   * @generated from field: vsmr.issue.v1.IssueAttachment attachment = 1;
   */
  attachment?: IssueAttachment;

  /**
   * @generated from field: bytes content = 2;
   */
  content = new Uint8Array(0);

  constructor(data?: PartialMessage<GetIssueAttachmentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.issue.v1.GetIssueAttachmentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "attachment", kind: "message", T: IssueAttachment },
    { no: 2, name: "content", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIssueAttachmentResponse {
    return new GetIssueAttachmentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIssueAttachmentResponse {
    return new GetIssueAttachmentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIssueAttachmentResponse {
    return new GetIssueAttachmentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetIssueAttachmentResponse | PlainMessage<GetIssueAttachmentResponse> | undefined, b: GetIssueAttachmentResponse | PlainMessage<GetIssueAttachmentResponse> | undefined): boolean {
    return proto3.util.equals(GetIssueAttachmentResponse, a, b);
  }
}

